"use client";
import { usePowerSearch } from "../contexts/power-search-context";
import MultiSelectWithSearch from "../MultiSelectWithSearch";
import Button from "react-bootstrap/Button";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { mixpanelTrack } from "shared/trackEvents/mixpanelTracking";
import { isOpenRemunerationPlan } from "shared/plans";
import {
  POWER_SEARCH_EVENT_NAMES,
  MIXPANEL_PROPS,
} from "shared/trackEvents/constants";

const MultiSelectSkillsWithSelectAll = ({
  skillsList,
  filterKey,
  title,
  currentFilterValue,
  all_skills,
  updateFilter,
  dispatchLocal,
}) => {
  const currentUser = useSelector((state) => state.users.user);

  if (!skillsList || skillsList.length === 0) return null;

  const options = skillsList.map((skill) => ({ label: skill, value: skill }));

  const handleSelectAll = useCallback(() => {
    const newAllSkillsState = !all_skills;
    dispatchLocal({
      type: "SET_FILTER",
      payload: { name: "all_skills", value: newAllSkillsState },
    });
    updateFilter(filterKey, newAllSkillsState ? options : []);
  }, [all_skills, dispatchLocal, updateFilter, filterKey, options]);

  const handleChange = useCallback(
    (value) => {
      updateFilter(filterKey, value);
      if (value.length === 0 && all_skills) {
        dispatchLocal({
          type: "SET_FILTER",
          payload: { name: "all_skills", value: false },
        });
      }

      // Track skills filter selection
      if (value.length > 0) {
        const eventName = isOpenRemunerationPlan(currentUser)
          ? POWER_SEARCH_EVENT_NAMES.OR_POWER_SEARCH_FILTER_SKILLS_CLICKED
          : POWER_SEARCH_EVENT_NAMES.OD_POWER_SEARCH_FILTER_SKILLS_CLICKED;

        mixpanelTrack(eventName, {
          [MIXPANEL_PROPS.FILTER_OPTION]: value[value.length - 1],
          [MIXPANEL_PROPS.FILTER_CATEGORY]: title,
          userEmail: currentUser?.email,
        });
      }
    },
    [updateFilter, filterKey, all_skills, dispatchLocal, currentUser, title]
  );

  return (
    <div
      className="mt-2"
      style={{ borderBottom: "1px solid #EDECE6", paddingBottom: "10px" }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <p
          className="mb-0"
          style={{ fontSize: "14px", fontWeight: "500", color: "#AF6A3A" }}
        >
          {title}
        </p>
        <Button variant="link" onClick={handleSelectAll} className="small p-0">
          {!all_skills ? "Select all" : "Unselect all"}
        </Button>
      </div>
      <MultiSelectWithSearch
        options={options}
        value={currentFilterValue}
        onChange={handleChange}
        placeholder={`Select ${title}`}
        className={"form-input debounce-search-input mt-1"}
      />
    </div>
  );
};

const SkillsFilter = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    filterOptions,
    skills_and_experience,
    all_skills,
    updateFilter,
    dispatchLocal,
  } = usePowerSearch();

  const skillsList = filterOptions.skill_and_experiences_list || [];

  if (skillsList.length === 0) return null;

  return (
    <div className="">
      <div
        className="d-flex align-items-center"
        style={{ cursor: "pointer" }}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <Button
          variant="link"
          size="sm"
          style={{
            display: "inline-block",
            padding: 0,
            margin: 0,
            textDecoration: "none",
            marginRight: "4px",
            focus: "none",
            outline: "none",
            border: "none",
            boxShadow: "none",
            fontWeight: "bold",
          }}
        >
          {isExpanded ? "−" : "+"}
        </Button>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            margin: 0,
          }}
        >
          SKILLS AND EXPERIENCE
        </p>
      </div>
      <div className={`${isExpanded ? "d-block" : "d-none"}`}>
        <MultiSelectSkillsWithSelectAll
          skillsList={skillsList}
          filterKey="skills_and_experience"
          title="Skills and Experience"
          currentFilterValue={skills_and_experience}
          all_skills={all_skills}
          updateFilter={updateFilter}
          dispatchLocal={dispatchLocal}
        />
      </div>
    </div>
  );
};

export default SkillsFilter;
